function cleanName(name: string) {
    if (!name) {
        return "";
    }
    try {
        return `${name}`.replace(/ \(.*\)/, "").trim();
    } catch (e) {
        return name;
    }
}

const crc32Lookup = Uint32Array.from({length: 256}, (_, c) => {
    for (let _ = 0; _ < 8; _++)
        c = ((c & 1) * 0xEDB88320) ^ (c >>> 1);
    return c;
});

function crc32(buf: Uint8Array, crc = 0) {
    crc = ~crc;
    for (let i = 0; i < buf.length; i++)
        crc = (crc >>> 8) ^ crc32Lookup[(crc ^ buf[i]) & 0xff];
    return ~crc >>> 0;
}

export function stringToColor(name: string) {
    name = cleanName(name);
    if ( ! name ) {
        return "#000000"; // Return a default color if the string is empty or undefined
    }

    const hash = crc32(new TextEncoder().encode(name));
  
    const rgb = [0, 0, 0];
    for (let i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0x7f;
        rgb[i] = value;
    }
    const color = "#" 
        + `00${rgb[0].toString(16)}`.slice(-2) 
        + `00${rgb[1].toString(16)}`.slice(-2) 
        + `00${rgb[2].toString(16)}`.slice(-2);

    // console.log(`stringToColor: string=${name}, hash=${hash}, color=${rgb[0] + rgb[1] + rgb[2]}`);
    return color;
  }
  
export function stringAvatar(name: string) {
    name = cleanName(name);
    if(!name || name.trim().length === 0) {
        return "??";
    }
    const tokens = `${name}`.split(" ");
    if (tokens.length == 1) {
        if (tokens[0].length > 1) {
            return `${tokens[0][0]}${tokens[0][1]}`.toUpperCase();
        }
        return `${tokens[0][0]}`.toUpperCase();
    }
    return `${tokens[0][0]}${tokens[tokens.length-1][0]}`.toUpperCase();
}